import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

export enum ProductMigrationAction {
  Skip = 0,
  Overwrite = 1,
  Append = 2,
}

export interface ProductMigrationDecision {
  productId: string;
  action: ProductMigrationAction;
}

export interface ProductRef {
  id: string;
  name?: string | null;
}

export interface RelatedProductsEntryView {
  programId?: string | null;
  name?: string | null;
  nameTranslations?: { [key: string]: string } | null;
  products: ProductRef[];
}

export interface ProductMigrationPreviewItem {
  productId: string;
  productName?: string | null;
  source: RelatedProductsEntryView[];
  target: RelatedProductsEntryView[];
  hasConflict: boolean;
}

export interface ProductMigrationExecuteResult {
  applied: number;
  skipped: number;
  failed: number;
  errors: string[];
}

export type MigrationMode = 'legacy-to-v2' | 'v2-to-v3';

@Injectable({
  providedIn: 'root',
})
export class RelatedProductsMigrationService {
  private requestPath = `${environment.posBaseUrl}/api/front/related-products-migration`;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) {}

  async preview(mode: MigrationMode, menuSectionId: string): Promise<ProductMigrationPreviewItem[]> {
    return firstValueFrom(
      this.http.get<ProductMigrationPreviewItem[]>(
        `${this.requestPath}/section/${menuSectionId}/${mode}/preview`,
        { headers: this.headers }
      )
    );
  }

  async execute(
    mode: MigrationMode,
    menuSectionId: string,
    decisions: ProductMigrationDecision[]
  ): Promise<ProductMigrationExecuteResult> {
    return firstValueFrom(
      this.http.post<ProductMigrationExecuteResult>(
        `${this.requestPath}/section/${menuSectionId}/${mode}/execute`,
        decisions,
        { headers: this.headers }
      )
    );
  }
}
